"use client";

import { useEffect } from "react";

import { CommandPaletteHotkeys } from "@/shared/lib/command-palette-hotkeys";
import { CommandPaletteProvider } from "@/shared/lib/use-command-palette";
import { registerServiceWorker } from "@/shared/lib/service-worker-register";
export function ClientWrapper({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  useEffect(() => {
    registerServiceWorker();
  }, []);

  const content = (
    <>
      <CommandPaletteHotkeys />
      {children}
    </>
  );
  return (
    <CommandPaletteProvider>
      {className ? <div className={className}>{content}</div> : content}
    </CommandPaletteProvider>
  );
}
